import { ProductsActivityEvents } from "./products.activities";

export * from "./products.activities";

export const ProductActivityEvents = {
  ...ProductsActivityEvents,
} as const;
